import _implicitStylesheets from "./linkWithIcon.css";
import _implicitScopedStylesheets from "./linkWithIcon.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import _aceLink from "ace/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span${3}>${"t1"}</span>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element} = $api;
  return [api_custom_element("ace-link", _aceLink, {
    props: {
      "name": $cmp.caption
    },
    key: 0
  }, [api_element("a", {
    attrs: {
      "href": $cmp.url,
      "target": "_blank"
    },
    key: 1
  }, [api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.caption))]), api_custom_element("ads-icon", _adsIcon, {
    props: {
      "size": "small",
      "symbol": $cmp.icon
    },
    key: 4
  })])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-43mtvprkshb";
tmpl.legacyStylesheetToken = "undefined-_linkWithIcon";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
